import Component from '@glimmer/component';
import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import AlertBanner from 'tio-ui/components/alert-banner';
import Button from 'tio-ui/components/button';

export default class ObservabilityUploadInfoRec extends Component {
  @service declare router: RouterService;

  navigateToView = async () => {
    await this.router.transitionTo('authenticated.account-activity.accounts');
    // Use 300ms delay to ensure this runs after application route's
    // requestAnimationFrame scroll restoration (consistent with tuition-assistance.gts)
    setTimeout(() => {
      const element = document.getElementById('my-documents');
      element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 300);
  };

  navigateToUpload = () => {
    this.router.transitionTo('authenticated.observability.upload', {
      queryParams: { source: 'wellness', providers: 'nslds,statement' },
    });
  };
  <template>
    <AlertBanner @intent="info">
      <p class="text-sm">
        {{t "wellness_insights.student_loan_insights.results_based_on"}}
        <Button
          @appearance="minimal"
          @size="sm"
          class="wellness-insights-inline-action underline p-0 h-auto"
          {{on "click" this.navigateToView}}
        >
          {{t "wellness_insights.student_loan_insights.your_loan_documents"}}
        </Button>.
        {{t "wellness_insights.student_loan_insights.refresh_insights"}}
        <Button
          @appearance="minimal"
          @size="sm"
          class="wellness-insights-inline-action underline p-0 h-auto"
          {{on "click" this.navigateToUpload}}
        >
          {{t "wellness_insights.student_loan_insights.upload_new_document"}}
        </Button>.
      </p>
    </AlertBanner>
  </template>
}
